//Auth Config for MSAL
export const msalConfig = {
    auth: {
        clientId:"aec0867e-1c70-4a08-8da3-5ea64bdac45b",
        authority: "https://login.microsoftonline.com/6017f842-b494-4e2c-a7be-93814b44805a",
        redirectUri: "http://localhost:3000/dynamic/Boxfusion.Projectmanagement/landing-page-timesheet-tab",
        postLogoutRedirectUri: "",
        navigateToLoginRequestUrl: false,
    },
    cache: {
        cacheLocation: "sessionStorage", 
        storeAuthStateInCookie: true, 
    }
};

export const loginRequest = {
    scopes: ["User.Read", "profile"],
    prompt: "select_account",
};